import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

import FileUploadField from '../Components/FileUploadField';
import WarningPanel from './WarningPanel';

export const AddNewVerificationCodeComponent = ({ userId, onReloadContent }) => {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();

    const [verificationCode, setVerificationCode] = React.useState('');
    
    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState(null);

    const handleChange = (field) => (e) => {
        const value = e.target.value;

        setVerificationCode(value);
        setStatus(null);

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[field];
        return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
    const validateForm = () => {
        const newErrors = {};

        if (verificationCode.length !== 6) {
            newErrors.verificationCode = 'Код должен содержать 6 цифр';
        }

        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const handleAddNewVerificationCode = () => {
        setLoading(true);
        const token = localStorage.getItem('token');

        axios.put('/api/save-user-verification-code', {
            verificationCode: verificationCode,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then(() => {
            if (location.pathname.startsWith('/essential-data')) {
                navigate('/home');
            } else {
                openTimeModal('Код сохранен', 'success');
                onReloadContent();
            }
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const handleSave = () => {
        if (validateForm()) {
            handleAddNewVerificationCode();
        }
    };


    return (
        <div className='panel'>
            <div className='panelHeader'>
                <h3>Придумайте код для восстановления доступа у аккаунту в случае утраты доступа</h3>
            </div>
            <div className='panelMain'>
                <div className='labelInputWrapper'>
                    <a className='label'>Код</a>
                    <div className='labelInputRight'>
                        <div className='inputWrapper'>
                            <InputMask
                                mask="999999"
                                value={verificationCode}
                                onChange={handleChange('verificationCode')}
                                maskChar={null}
                                >
                                {(inputProps) => (
                                    <input
                                        {...inputProps}
                                        type='text'
                                        placeholder='Придумайте 6-значный числовой код'
                                        className={errorsForm.verificationCode ? 'inputError' : ''}
                                    />
                                )}
                            </InputMask>
                            {errorsForm.verificationCode && <div className='errorUnderInput'>{errorsForm.verificationCode}</div>}
                            <span style={{height: '5px'}}></span>
                            <WarningPanel
                                text={'Запишите этот код в надежном месте'}
                                type={'error'}
                            />
                            <span style={{height: '5px'}}></span>
                            <WarningPanel 
                                text={'Код должен быть уникальным и не использоваться в других сервисах. Не пересылайте его по электронной почте и не передавайте никому, кроме СРО, и только при вашем обращении за восстановлением доступа к учётной записи. Сотрудники аппарата СРО и технической службы никогда не запрашивают этот код самостоятельно вне процедуры восстановления доступа — если кто-то просит его прислать, это признак мошенничества'}
                                type={'warning'}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='panelBottom'>
                <div>
                    {status}
                </div>
                {loading ? 
                    <Loading type='inline' />
                :
                <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                >
                    Сохранить
                </button>}
            </div>
        </div>
    )
}
